/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MonthOfBirth/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import BackAction from './BackAction/index'
import ChoiceRadial from 'DesignSystem/ChoiceRadial/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Timeout from 'DesignSystem/Timeout/react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function MonthOfBirth({
  children,
  viewPath = "/App/Account/MonthOfBirth",
  from
  
}) {
  let isBefore = useIsBefore()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let checkinMonthOfBirthValueData = fromData.useDataValue({ viewPath,
context: 'checkin',
path: 'month_of_birth',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  from
  
})
  return (<React.Fragment
>
<div
  data-testid="MonthOfBirth.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-1eNHDa': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="MonthOfBirth.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 text="Please select your birth month"
 marginRight="auto"
/>
</div>
<div
  data-testid="MonthOfBirth.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="choice_radial"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/ChoiceRadial(${item?.id ?? item?._id ?? index})`}
      >
<ChoiceRadial
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/ChoiceRadial(${item?.id ?? item?._id ?? index})`}
 width="30%"
 marginBottom={8}
 marginRight={8}
 paddingTop={26}
 paddingBottom={26}
 onClick={onClick}
 data="checkin.month_of_birth"
 selected={checkinMonthOfBirthValueData}
/>
</ListItem>
)}
</div>
<Timeout
  viewPath={`${viewPath}/Timeout`}
 onTimeout={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Start'))}
 delay={20000}
/>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }